type ApiErrorShape = {
  code?: number;
  status?: number;
  response?: {
    status?: number;
    data?: {
      code?: number;
    };
  };
};

export const getHttpErrorStatus = (error: unknown): number | undefined => {
  if (!error || typeof error !== "object") {
    return undefined;
  }

  const err = error as ApiErrorShape;

  return (
    err.code ??
    err.status ??
    err.response?.status ??
    err.response?.data?.code
  );
};

export const isForbiddenError = (error: unknown): boolean =>
  getHttpErrorStatus(error) === 403;
